<svelte:options accessors/>
<script>
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let data;
    export let columns;
    export let pages;
    export let filters;
    export let count;

    function descargarReporte() {
        alert('Descargando reporte excel...');
    }
</script>

<div class="py-15">
    <NauiExplorer {data} {pages} {count} {columns} {filters}
                  searchLabel="Buscar por servicio o cliente" paginate={true} on:filter on:next>
        <div slot="actions">
            <div class="flex">
                <NauiButton on:click={descargarReporte} caption="DESCARGAR REPORTE" mode="stroked"/>
            </div>
        </div>
    </NauiExplorer>
</div>
